export default {
    // 要开启 window.localStorage.setItem('local_dev', true) 否则会报404
    // /shopadmin/entity/goodsleishi
    "data": [
        {
            "shopmenu_id": "10146",
            "company_id": 0,
            "name": "\u5546\u54c1",
            "url": "\/shopadmin\/entity",
            "sort": 2,
            "is_menu": true,
            "pid": "0",
            "icon": "shopping-bag",
            "is_show": true,
            "alias_name": "entity",
            "version": 3,
            "disabled": false,
            "created": 1661939959,
            "updated": 1689504184,
            "menu_type": [
                "all"
            ],
            "level": 1,
            "isChildrenMenu": true,
            "children": [
                {
                    "shopmenu_id": "10679",
                    "company_id": 0,
                    "name": "\u96f7\u58eb\u5546\u54c1\u7ba1\u7406",
                    "url": "\/shopadmin\/entity\/goodsleishi",
                    "sort": 1,
                    "is_menu": true,
                    "pid": "10146",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "goodsleishi",
                    "version": 3,
                    "disabled": false,
                    "created": 1678430922,
                    "updated": 1696904991,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10147",
                    "company_id": 0,
                    "name": "\u95e8\u5e97\u81ea\u6709\u5546\u54c1",
                    "url": "\/shopadmin\/entity\/goodsphysical",
                    "sort": 2,
                    "is_menu": true,
                    "pid": "10146",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "goodsphysical",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1747802663,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10172",
                    "company_id": 0,
                    "name": "\u5546\u54c1\u5bfc\u5165",
                    "url": "\/shopadmin\/entity\/physicalupload",
                    "sort": 2,
                    "is_menu": true,
                    "pid": "10146",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "physicalupload",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10148",
                    "company_id": 0,
                    "name": "\u5546\u54c1\u54c1\u724c",
                    "url": "\/shopadmin\/entity\/goodsbrand",
                    "sort": 3,
                    "is_menu": true,
                    "pid": "10146",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "goodsbrand",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10149",
                    "company_id": 0,
                    "name": "\u5e97\u94fa\u5206\u7c7b",
                    "url": "\/shopadmin\/entity\/goodscategory",
                    "sort": 4,
                    "is_menu": true,
                    "pid": "10146",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "goodscategory",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661999822,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10150",
                    "company_id": 0,
                    "name": "\u5546\u54c1\u6807\u7b7e",
                    "url": "\/shopadmin\/entity\/itemtags",
                    "sort": 5,
                    "is_menu": true,
                    "pid": "10146",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "itemtags",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1786008506,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10490",
                    "company_id": 0,
                    "name": "\u5546\u54c1\u8bc4\u4ef7",
                    "url": "\/shopadmin\/entity\/rate",
                    "sort": 6,
                    "is_menu": true,
                    "pid": "10146",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "rate",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10151",
                    "company_id": 0,
                    "name": "\u7d20\u6750\u7ba1\u7406",
                    "url": "\/shopadmin\/entity\/brandmaterial",
                    "sort": 7,
                    "is_menu": true,
                    "pid": "10146",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "brandmaterial",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10687",
                    "company_id": 0,
                    "name": "\u5546\u54c1\u89c4\u683c",
                    "url": "\/shopadmin\/entity\/goodsattributes",
                    "sort": 8,
                    "is_menu": true,
                    "pid": "10146",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "goodsattributes",
                    "version": 3,
                    "disabled": false,
                    "created": 1685624148,
                    "updated": 1789701710,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                }
            ]
        },
        {
            "shopmenu_id": "10143",
            "company_id": 0,
            "name": "\u4ea4\u6613",
            "url": "\/shopadmin\/order",
            "sort": 3,
            "is_menu": true,
            "pid": "0",
            "icon": "clipboard-list",
            "is_show": true,
            "alias_name": "order",
            "version": 3,
            "disabled": false,
            "created": 1661939959,
            "updated": 1661939959,
            "menu_type": [
                "all"
            ],
            "level": 1,
            "isChildrenMenu": true,
            "children": [
                {
                    "shopmenu_id": "10144",
                    "company_id": 0,
                    "name": "\u5168\u90e8\u8ba2\u5355",
                    "url": "\/shopadmin\/order\/tradenormalorders",
                    "sort": 1,
                    "is_menu": true,
                    "pid": "10143",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "shoptradenormalorders",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1786346864,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10145",
                    "company_id": 0,
                    "name": "\u4ea4\u6613\u5355",
                    "url": "\/shopadmin\/order\/tradepayment",
                    "sort": 2,
                    "is_menu": true,
                    "pid": "10143",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "tradepayment",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1678437097,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10152",
                    "company_id": 0,
                    "name": "\u552e\u540e\u5217\u8868",
                    "url": "\/shopadmin\/order\/aftersaleslist",
                    "sort": 4,
                    "is_menu": true,
                    "pid": "10143",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "aftersaleslist",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10641",
                    "company_id": 0,
                    "name": "\u9000\u6b3e\u5355",
                    "url": "\/shopadmin\/order\/aftersalesrefundlist",
                    "sort": 5,
                    "is_menu": true,
                    "pid": "10143",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "aftersalesrefundlist",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10153",
                    "company_id": 0,
                    "name": "\u8fd0\u8d39\u6a21\u677f",
                    "url": "\/shopadmin\/order\/shippingtemplates",
                    "sort": 5,
                    "is_menu": true,
                    "pid": "10143",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "shippingtemplates",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10213",
                    "company_id": 0,
                    "name": "\u7269\u6d41\u516c\u53f8",
                    "url": "\/shopadmin\/order\/logistics",
                    "sort": 6,
                    "is_menu": true,
                    "pid": "10143",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "wl-logistics",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                }
            ]
        },
        {
            "shopmenu_id": "10154",
            "company_id": 0,
            "name": "\u4f1a\u5458",
            "url": "\/shopadmin\/member",
            "sort": 4,
            "is_menu": true,
            "pid": "0",
            "icon": "gem1",
            "is_show": true,
            "alias_name": "member",
            "version": 3,
            "disabled": false,
            "created": 1661939959,
            "updated": 1714365852,
            "menu_type": [
                "all"
            ],
            "level": 1,
            "isChildrenMenu": true,
            "children": [
                {
                    "shopmenu_id": "10155",
                    "company_id": 0,
                    "name": "\u4f1a\u5458\u7ba1\u7406",
                    "url": "\/shopadmin\/member\/member",
                    "sort": 1,
                    "is_menu": true,
                    "pid": "10154",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "member-list-view",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1762303871,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2,
                    "isChildrenMenu": false,
                    "children": [
                        {
                            "shopmenu_id": "10157",
                            "company_id": 0,
                            "name": "\u7fa4\u53d1\u4f18\u60e0\u5238",
                            "url": "\/shopadmin\/member\/member",
                            "sort": 1,
                            "is_menu": false,
                            "pid": "10155",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "member-send-coupons",
                            "version": 3,
                            "disabled": false,
                            "created": 1661939959,
                            "updated": 1661939959,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        },
                        {
                            "shopmenu_id": "10174",
                            "company_id": 0,
                            "name": "\u4f1a\u5458\u5bfc\u51fa",
                            "url": "\/shopadmin\/member\/member",
                            "sort": 1,
                            "is_menu": false,
                            "pid": "10155",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "member-export",
                            "version": 3,
                            "disabled": false,
                            "created": 1661939959,
                            "updated": 1661939959,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        },
                        {
                            "shopmenu_id": "10159",
                            "company_id": 0,
                            "name": "\u6253\u6807\u7b7e",
                            "url": "\/shopadmin\/member\/member",
                            "sort": 3,
                            "is_menu": false,
                            "pid": "10155",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "member-tag",
                            "version": 3,
                            "disabled": false,
                            "created": 1661939959,
                            "updated": 1661939959,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        }
                    ]
                },
                {
                    "shopmenu_id": "10156",
                    "company_id": 0,
                    "name": "\u4f1a\u5458\u6807\u7b7e",
                    "url": "\/shopadmin\/member\/Managetag",
                    "sort": 2,
                    "is_menu": true,
                    "pid": "10154",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "Managetag",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1717055541,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10673",
                    "company_id": 0,
                    "name": "\u5e97\u94fa\u4f1a\u5458\u7b49\u7ea7",
                    "url": "\/shopadmin\/member\/XyShopMembersGrade",
                    "sort": 3,
                    "is_menu": true,
                    "pid": "10154",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "XyShopMembersGrade",
                    "version": 3,
                    "disabled": false,
                    "created": 1662116785,
                    "updated": 1772179172,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10714",
                    "company_id": 0,
                    "name": "\u9884\u7ea6\u5230\u5e97",
                    "url": "\/shopadmin\/member\/appointment\/list",
                    "sort": 5,
                    "is_menu": true,
                    "pid": "10154",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "appointment",
                    "version": 3,
                    "disabled": false,
                    "created": 1787557832,
                    "updated": 1787558323,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                }
            ]
        },
        {
            "shopmenu_id": "10160",
            "company_id": 0,
            "name": "\u5e97\u94fa",
            "url": "\/shopadmin\/store",
            "sort": 4,
            "is_menu": true,
            "pid": "0",
            "icon": "store-alt",
            "is_show": true,
            "alias_name": "store",
            "version": 3,
            "disabled": false,
            "created": 1661939959,
            "updated": 1714363584,
            "menu_type": [
                "all"
            ],
            "level": 1,
            "isChildrenMenu": true,
            "children": [
                {
                    "shopmenu_id": "10161",
                    "company_id": 0,
                    "name": "\u5e97\u94fa\u4fe1\u606f",
                    "url": "\/shopadmin\/store\/marketingdistributor",
                    "sort": 1,
                    "is_menu": true,
                    "pid": "10160",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "marketingdistributor",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1788420234,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10170",
                    "company_id": 0,
                    "name": "\u5e97\u94fa\u7801",
                    "url": "\/shopadmin\/store\/distributorCode",
                    "sort": 2,
                    "is_menu": true,
                    "pid": "10160",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "distributorCode",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                }
            ]
        },
        {
            "shopmenu_id": "10162",
            "company_id": 0,
            "name": "\u8425\u9500",
            "url": "\/shopadmin\/marketing",
            "sort": 5,
            "is_menu": true,
            "pid": "0",
            "icon": "gift",
            "is_show": true,
            "alias_name": "marketing",
            "version": 3,
            "disabled": false,
            "created": 1661939959,
            "updated": 1661939959,
            "menu_type": [
                "all"
            ],
            "level": 1,
            "isChildrenMenu": true,
            "children": [
                {
                    "shopmenu_id": "10163",
                    "company_id": 0,
                    "name": "\u4f18\u60e0\u5238",
                    "url": "\/shopadmin\/marketing\/coupon",
                    "sort": 1,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "coupon",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1732004461,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2,
                    "isChildrenMenu": true,
                    "children": [
                        {
                            "shopmenu_id": "10165",
                            "company_id": 0,
                            "name": "\u4f18\u60e0\u5238\u7ba1\u7406",
                            "url": "\/shopadmin\/marketing\/coupon\/membermarketing",
                            "sort": 1,
                            "is_menu": true,
                            "pid": "10163",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "membermarketing",
                            "version": 3,
                            "disabled": false,
                            "created": 1661939959,
                            "updated": 1689504507,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        },
                        {
                            "shopmenu_id": "10166",
                            "company_id": 0,
                            "name": "\u53d1\u5238\u8bb0\u5f55",
                            "url": "\/shopadmin\/marketing\/coupon\/coupongive",
                            "sort": 2,
                            "is_menu": true,
                            "pid": "10163",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "coupongive",
                            "version": 3,
                            "disabled": false,
                            "created": 1661939959,
                            "updated": 1661939959,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        }
                    ]
                },
                {
                    "shopmenu_id": "10637",
                    "company_id": 0,
                    "name": "\u52a0\u4ef7\u8d2d",
                    "url": "\/shopadmin\/marketing\/Marketingspluspricebuy",
                    "sort": 2,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "marketingspluspricebuy",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10638",
                    "company_id": 0,
                    "name": "\u7ec4\u5408\u8d2d",
                    "url": "\/shopadmin\/marketing\/marketingpackage",
                    "sort": 3,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "marketingpackage",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10689",
                    "company_id": 0,
                    "name": "\u65b0\u7ec4\u5408\u5957\u9910",
                    "url": "\/shopadmin\/marketing\/packagenew",
                    "sort": 3,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "packagenew",
                    "version": 3,
                    "disabled": false,
                    "created": 1689504283,
                    "updated": 1689504301,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10212",
                    "company_id": 0,
                    "name": "\u9650\u65f6\u4f18\u60e0",
                    "url": "\/shopadmin\/marketing\/marketing\/limitedtimesale",
                    "sort": 4,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "limitedtimesale",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10639",
                    "company_id": 0,
                    "name": "\u5546\u54c1\u9650\u8d2d",
                    "url": "\/shopadmin\/marketing\/goodslimit",
                    "sort": 5,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "goodslimit",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1713769327,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10640",
                    "company_id": 0,
                    "name": "\u9650\u65f6\u79d2\u6740",
                    "url": "\/shopadmin\/marketing\/marketingseckill",
                    "sort": 6,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "marketingseckill",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1770534586,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10688",
                    "company_id": 0,
                    "name": "\u9884\u5b58\u6b3e",
                    "url": "\/shopadmin\/marketing\/yucunkuan",
                    "sort": 6,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "yucunkuan",
                    "version": 3,
                    "disabled": false,
                    "created": 1689504249,
                    "updated": 1689504259,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10167",
                    "company_id": 0,
                    "name": "\u6ee1\u6298",
                    "url": "\/shopadmin\/marketing\/marketingsfulldiscount",
                    "sort": 7,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "marketingsfulldiscount",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10164",
                    "company_id": 0,
                    "name": "\u6ee1\u51cf",
                    "url": "\/shopadmin\/marketing\/marketingsfullminus",
                    "sort": 8,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "marketingsfullminus",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10168",
                    "company_id": 0,
                    "name": "\u6ee1\u8d60",
                    "url": "\/shopadmin\/marketing\/marketingsfullgift",
                    "sort": 9,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "marketingsfullgift",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10690",
                    "company_id": 0,
                    "name": "\u65b0\u6ee1\u8d60",
                    "url": "\/shopadmin\/marketing\/marketingsfullgiftnew",
                    "sort": 9,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "marketingsfullgiftnew",
                    "version": 3,
                    "disabled": false,
                    "created": 1689504340,
                    "updated": 1689504349,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10691",
                    "company_id": 0,
                    "name": "\u62fc\u56e2\u6d3b\u52a8",
                    "url": "\/shopadmin\/marketing\/groupsindex",
                    "sort": 9,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "groupsindex",
                    "version": 3,
                    "disabled": false,
                    "created": 1689504543,
                    "updated": 1689504561,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10692",
                    "company_id": 0,
                    "name": "\u6ee1\u8fd4",
                    "url": "\/shopadmin\/marketing\/marketingsfullcoupon",
                    "sort": 9,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "marketingsfullcoupon",
                    "version": 3,
                    "disabled": false,
                    "created": 1689504586,
                    "updated": 1689504600,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10693",
                    "company_id": 0,
                    "name": "\u7b2c\u4e8c\u4ef6\u534a\u4ef7",
                    "url": "\/shopadmin\/marketing\/marketingstwohalf",
                    "sort": 9,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "marketingstwohalf",
                    "version": 3,
                    "disabled": false,
                    "created": 1689504624,
                    "updated": 1689504637,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10694",
                    "company_id": 0,
                    "name": "\u5206\u9500\u63a8\u5e7f",
                    "url": "\/shopadmin\/marketing\/popularize",
                    "sort": 11,
                    "is_menu": true,
                    "pid": "10162",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "popularize",
                    "version": 3,
                    "disabled": false,
                    "created": 1689504707,
                    "updated": 1689504707,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2,
                    "isChildrenMenu": true,
                    "children": [
                        {
                            "shopmenu_id": "10695",
                            "company_id": 0,
                            "name": "\u57fa\u7840\u914d\u7f6e",
                            "url": "\/shopadmin\/marketing\/popularize\/popularizesetting",
                            "sort": 1,
                            "is_menu": true,
                            "pid": "10694",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "popularizesetting",
                            "version": 3,
                            "disabled": false,
                            "created": 1689504727,
                            "updated": 1689504748,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        },
                        {
                            "shopmenu_id": "10696",
                            "company_id": 0,
                            "name": "\u63a8\u5e7f\u4eba\u7ba1\u7406",
                            "url": "\/shopadmin\/marketing\/popularize\/popularizelist",
                            "sort": 2,
                            "is_menu": true,
                            "pid": "10694",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "popularizelist",
                            "version": 3,
                            "disabled": false,
                            "created": 1689504770,
                            "updated": 1689504780,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        },
                        {
                            "shopmenu_id": "10697",
                            "company_id": 0,
                            "name": "\u5206\u9500\u5546\u54c1",
                            "url": "\/shopadmin\/marketing\/popularize\/popularizegoods",
                            "sort": 3,
                            "is_menu": true,
                            "pid": "10694",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "popularizegoods",
                            "version": 3,
                            "disabled": false,
                            "created": 1689504800,
                            "updated": 1689504810,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        },
                        {
                            "shopmenu_id": "10698",
                            "company_id": 0,
                            "name": "\u63a8\u5e7f\u5458\u4e1a\u7ee9",
                            "url": "\/shopadmin\/marketing\/popularize\/popularizedata",
                            "sort": 4,
                            "is_menu": true,
                            "pid": "10694",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "popularizedata",
                            "version": 3,
                            "disabled": false,
                            "created": 1689504832,
                            "updated": 1689504832,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        },
                        {
                            "shopmenu_id": "10699",
                            "company_id": 0,
                            "name": "\u63d0\u73b0\u7533\u8bf7",
                            "url": "\/shopadmin\/marketing\/popularize\/popularizewithdraw",
                            "sort": 5,
                            "is_menu": true,
                            "pid": "10694",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "popularizewithdraw",
                            "version": 3,
                            "disabled": false,
                            "created": 1689504860,
                            "updated": 1689504869,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        }
                    ]
                }
            ]
        },
        {
            "shopmenu_id": "10178",
            "company_id": 0,
            "name": "\u62a5\u8868",
            "url": "\/shopadmin\/statistics",
            "sort": 7,
            "is_menu": true,
            "pid": "0",
            "icon": "chart-bar",
            "is_show": true,
            "alias_name": "statistics",
            "version": 3,
            "disabled": false,
            "created": 1661939959,
            "updated": 1661939959,
            "menu_type": [
                "all"
            ],
            "level": 1,
            "isChildrenMenu": true,
            "children": [
                {
                    "shopmenu_id": "10205",
                    "company_id": 0,
                    "name": "\u5e97\u94fa\u7edf\u8ba1",
                    "url": "\/shopadmin\/statistics\/distributordata",
                    "sort": 1,
                    "is_menu": true,
                    "pid": "10178",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "distributordata",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10633",
                    "company_id": 0,
                    "name": "\u7ed3\u7b97",
                    "url": "\/shopadmin\/statistics\/financial\/settlement",
                    "sort": 2,
                    "is_menu": true,
                    "pid": "10178",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "settlement",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2,
                    "isChildrenMenu": true,
                    "children": [
                        {
                            "shopmenu_id": "10634",
                            "company_id": 0,
                            "name": "\u7ed3\u7b97\u6c47\u603b",
                            "url": "\/shopadmin\/statistics\/financial\/settlement\/summary",
                            "sort": 1,
                            "is_menu": true,
                            "pid": "10633",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "summary",
                            "version": 3,
                            "disabled": false,
                            "created": 1661939959,
                            "updated": 1661939959,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        }
                    ]
                }
            ]
        },
        {
            "shopmenu_id": "10268",
            "company_id": 0,
            "name": "\u8bbe\u7f6e",
            "url": "\/shopadmin\/shopsetting",
            "sort": 9,
            "is_menu": true,
            "pid": "0",
            "icon": "cog",
            "is_show": true,
            "alias_name": "shopsetting",
            "version": 3,
            "disabled": false,
            "created": 1661939959,
            "updated": 1661939959,
            "menu_type": [
                "all"
            ],
            "level": 1,
            "isChildrenMenu": true,
            "children": [
                {
                    "shopmenu_id": "10623",
                    "company_id": 0,
                    "name": "\u8d26\u53f7\u7ba1\u7406",
                    "url": "\/shopadmin\/shopsetting\/staff",
                    "sort": 1,
                    "is_menu": true,
                    "pid": "10268",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "distributor-staff",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "platform",
                        "standard",
                        "all"
                    ],
                    "level": 2,
                    "isChildrenMenu": true,
                    "children": [
                        {
                            "shopmenu_id": "10624",
                            "company_id": 0,
                            "name": "\u5e97\u94fa\u7ba1\u7406\u5458",
                            "url": "\/shopadmin\/shopsetting\/staff\/Merchantstaff",
                            "sort": 1,
                            "is_menu": true,
                            "pid": "10623",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "Merchant-staff",
                            "version": 3,
                            "disabled": false,
                            "created": 1661939959,
                            "updated": 1661939959,
                            "menu_type": [
                                "platform",
                                "standard"
                            ],
                            "level": 3
                        },
                        {
                            "shopmenu_id": "10625",
                            "company_id": 0,
                            "name": "\u5e97\u94fa\u89d2\u8272",
                            "url": "\/shopadmin\/shopsetting\/staff\/Merchantstaffroles",
                            "sort": 1,
                            "is_menu": true,
                            "pid": "10623",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "platformstaffroles",
                            "version": 3,
                            "disabled": false,
                            "created": 1661939959,
                            "updated": 1661939959,
                            "menu_type": [
                                "platform",
                                "standard"
                            ],
                            "level": 3
                        }
                    ]
                },
                {
                    "shopmenu_id": "10269",
                    "company_id": 0,
                    "name": "\u5bfc\u51fa\u5217\u8868",
                    "url": "\/shopadmin\/shopsetting\/baseexport",
                    "sort": 2,
                    "is_menu": true,
                    "pid": "10268",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "shop-baseexport",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2
                },
                {
                    "shopmenu_id": "10488",
                    "company_id": 0,
                    "name": "\u8131\u654f\u6570\u636e",
                    "url": "\/shopadmin\/shopsetting\/datapass",
                    "sort": 3,
                    "is_menu": true,
                    "pid": "10268",
                    "icon": null,
                    "is_show": true,
                    "alias_name": "datapass",
                    "version": 3,
                    "disabled": false,
                    "created": 1661939959,
                    "updated": 1661939959,
                    "menu_type": [
                        "all"
                    ],
                    "level": 2,
                    "isChildrenMenu": true,
                    "children": [
                        {
                            "shopmenu_id": "10489",
                            "company_id": 0,
                            "name": "\u6743\u9650\u7533\u8bf7",
                            "url": "\/shopadmin\/shopsetting\/datapass\/apply",
                            "sort": 1,
                            "is_menu": true,
                            "pid": "10488",
                            "icon": null,
                            "is_show": true,
                            "alias_name": "applyDataPass",
                            "version": 3,
                            "disabled": false,
                            "created": 1661939959,
                            "updated": 1661939959,
                            "menu_type": [
                                "all"
                            ],
                            "level": 3
                        }
                    ]
                }
            ]
        }
    ]
}